import countrySettings from './country-settings.json';

const { index, settings } = countrySettings;
/**
 * Check if a setting is enabled for a country.
 * @param locale {object}
 * @param [locale.country] {String}
 * @param [locale.language] {String}
 * @param setting {String} ie, COOKIE_SETTINGS
 * @returns {boolean}
 */
export default function isEnabled({ country: countryCode, language: languageCode }, setting) {
  const country = countryCode?.toLowerCase();
  const language = languageCode?.toLowerCase();
  const settingIndex = index.indexOf(setting.toUpperCase());

  if (settingIndex === -1) {
    throw new Error(`Setting not provided: ${setting}`);
  }

  // Return false by default, if config for particular country or language does not exist.
  if (!settings[country] || (language && !settings[country][language])) {
    return false;
  }

  // Return configs for particular language for particular country, if the both country and language are passed.
  // Return first available config for particular country, if language is not passed.
  return (settings[country][language] || Object.values(settings[country])[0])[settingIndex];
}
